import React, { useState, useEffect, useRef } from "react";
import { observer } from "mobx-react-lite";
import { voiceStore } from "../stores/voiceStore";

const languages = ["English", "Hindi", "Gujarati", "Marathi", "Tamil"];

// Language display mapping - English to native script
const languageDisplayMap = {
    "English": "English",
    "Hindi": "हिंदी",
    "Gujarati": "ગુજરાતી", 
    "Marathi": "मराठी",
    "Tamil": "தமிழ்"
};

const LanguageSelector = observer(() => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const dropdownRef = useRef(null);

    const handleLanguageChange = (language) => {
        voiceStore.setLanguage(language);
        sessionStorage.setItem("CommunicationLanguage", JSON.stringify(language));
        setIsOpen(false);
        setSearchTerm("");
    };

    const filteredLanguages = languages.filter((lang) =>
        lang.toLowerCase().includes(searchTerm.toLowerCase())
    );

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="relative inline-block z-50 text-[14px]" ref={dropdownRef}>
            {/* Select Box */}
            <div
                className="border rounded px-1 py-1 cursor-pointer flex justify-between items-center text-white bg-inherit  w-auto relative z-50"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="bg-transparent text-white cursor-pointer">
                    {languageDisplayMap[voiceStore.language] || voiceStore.language}
                </span>
                <span className="text-white">▼</span>
            </div>

            {/* Dropdown List */}
            {isOpen && (
                <div className="absolute w-auto  border rounded shadow-lg bg-white mt-1 z-50 text-gray-600 right-0">
                    {filteredLanguages.length > 0 ? (
                        filteredLanguages.map((lang) => (
                            <div
                                key={lang}
                                className="p-2 hover:bg-gray-600 cursor-pointer whitespace-nowrap"
                                onClick={() => handleLanguageChange(lang)}
                            >
                                {languageDisplayMap[lang]}
                            </div>
                        ))
                    ) : (
                        <div className="p-2 text-gray-300">No matches found</div>
                    )}
                </div>
            )}
        </div>
    );
});



export default LanguageSelector;
